import { HttpClient } from './httpClient';

export class BaseApiClient {
  protected readonly http: HttpClient;

  constructor(urlPrefix: string) {
    this.http = new HttpClient(urlPrefix);
  }
}
